<template>
	<div id="app">
		<div id="content">
			<div class="d-block d-md-none btn-mobile-menu" @click="showMenu" :class="show == true ? 'show' : ''">
				<img src="/assets/sidebar/icon-menu.png">
			</div>
			<ml-sidebar @action="toggleShow" @hover="triggerHide" :class="show == true ? 'show' : ''"></ml-sidebar>
			<i-modal ref="modalPublicPermission">
				<template v-slot:header>
					<div class="modal-header no-border p-3">
						<div class="modal-title font-size-12 font-size-sm-10 font-weight-bold">PERJANJIAN PUBLIKASI DATA MOBILE COUNTER MILAGROS
						</div>
						<button class="btn no-box-focus"><span @click="hideDetail" class="close-modal ml-2 color-red"><i
									class="fas fa-times"></i></span></button>
					</div>
				</template>
				<template v-slot:body>
					<div class="d-flex flex-column col-12 font-size-11 font-size-sm-9 pb-4 pt-0 mt-n3 pl-0 pr-0">
						<p class="font-size-11 font-weight-bold">
							MAKSUD DAN TUJUAN
						</p>
						<p class="font-size-11 mb-2" style="word-spacing: 4px;">
							<span class="font-weight-bold">Bahwa PT. Milagros Indonesia Megah</span> berkeinginan untuk mempublikasikan daftar
							resmi stockist Milagros guna memudahkan
							pelanggan dan calon pelanggan dalam menemukan ketersediaan produk di wilayah masing-masing. Untuk itu, di harapkan
							para Mobile Counter Milagros bersedia memberikan izin untuk menampilkan data pribadi berupa
							<span class="font-weight-bold">nama, alamat, dan nomor handphone/WhatsApp</span>
							pada media publikasi resmi Milagros.
						</p>
						<!-- <div class="d-flex justify-content-between mt-1">
							<button class="btn btn-blue rounded-cus box-purple" style="width: 240px;" @click="savePermission('allowed')">
								<div class="font-size-11 text-uppercase"><i class="fa fa-check mr-2"></i>Bersedia</div>
							</button>
							<button class="btn btn-blue rounded-cus box-purple" style="width: 240px;" @click="savePermission('unallowed')">
								<div class="font-size-11 text-uppercase"><i class="fa fa-times mr-2"></i>Tidak Bersedia</div>
							</button>
							<button class="btn btn-blue rounded-cus box-purple" style="width: 240px;" @click="savePermission('pending')">
								<div class="font-size-11 text-uppercase"><i class="fa fa-clock mr-2"></i>Tunda</div>
							</button>
						</div> -->
						<div class="form-check">
							<input class="form-check-input" type="radio" v-model="permission" id="permission1" value="allowed" checked>
							<label class="form-check-label" for="permission1">
								Bersedia
							</label>
						</div>
						<div class="form-check">
							<input class="form-check-input" type="radio" v-model="permission" id="permission2" value="unallowed">
							<label class="form-check-label" for="permission2">
								Tidak Bersedia
							</label>
						</div>
						<div class="form-check mb-2">
							<input class="form-check-input" type="radio" v-model="permission" id="permission3" value="pending">
							<label class="form-check-label" for="permission3">
								Tunda
							</label>
						</div>
						<div class="d-flex justify-content-end">
							<button class="btn btn-blue rounded-cus box-purple" style="width: 200px;" @click="savePermission()">
								<div class="font-size-11 text-uppercase">Simpan</div>
							</button>
						</div>
					</div>
				</template>
				<template v-slot:footer>
					<div class="footer-modal">
					</div>
				</template>
			</i-modal>
			<!-- <div class="trigger-hide" @click="triggerHide">isa</div> -->
			<router-view :class="hide == true ? 'wide' : ''" />
		</div>
		<vue-progress-bar />
	</div>
</template>

<script>
import IModal from '@/components/IModal.vue';
import { mapState, mapActions } from 'vuex'

export default {
	name: 'Main',
	components: {
		IModal,
	},
	data() {
		return {
			permission: 'pending',
			hide: true,
			show: false,
			navMobile: false,
		}
	},
	computed: {
		...mapState('auth', ['userData', 'is_have_pin']),
		...mapState('profileList', ['responSukses', 'konfirmResponse']),
	},
	methods: {
		...mapActions('profileList', ['setPublicPermission']),
		triggerHide() {
			if (!this.hide) {
				this.hide = true
			} else {
				this.hide = false
			}
		},
		showMenu() {
			if (!this.show) {
				this.show = true
			} else {
				this.show = false
			}
		},
		toggleShow(val) {
			this.show = val
		},
		hideDetail() {
			this.$refs.modalPublicPermission.modalHide()
		},
		savePermission() {
			if(this.permission == 'pending'){
				this.$refs.modalPublicPermission.modalHide()
				return
			} else {
				var params = {
                    permission: this.permission,
                }

                this.setPublicPermission(params).then(() => {
                    //console.log(this.responSukses)
                    if (this.responSukses == 200) {
                        this.$refs.modalPublicPermission.modalHide()
                    }
                })
			}
		}
	},
	mounted() {		
		if (this.userData.stockist_public_permission === 'pending' && this.userData.stockist_type== 'utama' && this.is_have_pin == true) {
			this.$refs.modalPublicPermission.modalShow()
		}
	},
};
</script>

<style>
.trigger-hide {
	position: absolute;
	z-index: 1;

	left: 50%;
}
</style>
